import { z } from 'zod';
import { hostSummaryDTOSchema, inviteDetailDTOSchema, inviteDTOSchema, issuedInviteDTOSchema, } from '@instanexus/contracts';
import { dataEnvelopeSchema, listEnvelopeSchema, WEB_API_PREFIX, } from '../transport.js';
const inviteListSchema = listEnvelopeSchema(inviteDTOSchema);
const inviteSchema = dataEnvelopeSchema(inviteDTOSchema);
const issuedInviteSchema = dataEnvelopeSchema(issuedInviteDTOSchema);
// `{ data }` with no `meta` — see `InvitesResource.searchHosts` and `VisitsResource.searchHosts`
// for why, and for what went wrong when a route like this was validated as a `listEnvelopeSchema`.
const hostListSchema = dataEnvelopeSchema(z.array(hostSummaryDTOSchema));
const inviteDetailSchema = dataEnvelopeSchema(inviteDetailDTOSchema);
export function createInvitesResource(transport) {
    return {
        async create(input) {
            const envelope = await transport.request({
                method: 'POST',
                path: `${WEB_API_PREFIX}/invites`,
                schema: issuedInviteSchema,
                body: input,
            });
            return envelope.data;
        },
        async list(query) {
            return transport.request({
                path: `${WEB_API_PREFIX}/invites`,
                schema: inviteListSchema,
                query: query === undefined
                    ? undefined
                    : {
                        page: query.page,
                        pageSize: query.pageSize,
                        sort: query.sort,
                        status: query.status,
                        locationId: query.locationId,
                        from: query.from,
                        to: query.to,
                        q: query.q,
                    },
            });
        },
        async cancel(id, options) {
            const body = options?.scope === undefined ? undefined : { scope: options.scope };
            const envelope = await transport.request({
                method: 'POST',
                path: `${WEB_API_PREFIX}/invites/${encodeURIComponent(id)}/cancel`,
                ...(body === undefined ? {} : { body }),
                schema: inviteSchema,
            });
            return envelope.data;
        },
        async searchHosts(query) {
            return transport.request({
                path: `${WEB_API_PREFIX}/invites/hosts`,
                schema: hostListSchema,
                query: { q: query.q },
            });
        },
        async resend(id) {
            const envelope = await transport.request({
                method: 'POST',
                path: `${WEB_API_PREFIX}/invites/${encodeURIComponent(id)}/resend`,
                schema: issuedInviteSchema,
            });
            return envelope.data;
        },
        async get(id) {
            const envelope = await transport.request({
                path: `${WEB_API_PREFIX}/invites/${encodeURIComponent(id)}`,
                schema: inviteDetailSchema,
            });
            return envelope.data;
        },
    };
}
//# sourceMappingURL=invites.js.map